import { render, staticRenderFns } from "./TechTransferMember.vue?vue&type=template&id=4f08d7ec&"
import script from "./TechTransferMember.vue?vue&type=script&lang=js&"
export * from "./TechTransferMember.vue?vue&type=script&lang=js&"
import style0 from "./TechTransferMember.vue?vue&type=style&index=0&id=4f08d7ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports